import { render, staticRenderFns } from "./HollowCard.vue?vue&type=template&id=476653fa&scoped=true&"
import script from "./HollowCard.vue?vue&type=script&lang=ts&"
export * from "./HollowCard.vue?vue&type=script&lang=ts&"
import style0 from "./HollowCard.vue?vue&type=style&index=0&id=476653fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476653fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476653fa')) {
      api.createRecord('476653fa', component.options)
    } else {
      api.reload('476653fa', component.options)
    }
    module.hot.accept("./HollowCard.vue?vue&type=template&id=476653fa&scoped=true&", function () {
      api.rerender('476653fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/HollowCard.vue"
export default component.exports